import React from 'react'

const PanelTitle = ({ displayName }) => (
  <h5 className='f5 mt0 mb6 fw6'>{displayName}</h5>
)

export default PanelTitle
